export default function ErrorAccordion({ id, error }) {
  return (
    <div className="accordion w-100" id={`errorAccordion-${id}`}>
      <div className="accordion-item">
        <h2 className="accordion-header" id={`headingError-${id}`}>
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapseError-${id}`}
            aria-expanded="false"
            aria-controls={`collapseError-${id}`}
          >
            Show Error Details
          </button>
        </h2>
        <div id={`collapseError-${id}`} className="accordion-collapse collapse" aria-labelledby={`headingError-${id}`} data-bs-parent={`#errorAccordion-${id}`}>
          <div className="accordion-body">
            <pre className="mb-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{error?.message}</pre>
          </div>
        </div>
      </div>
    </div>
  );
}
